export const APP_VERSION="v0.2.0_rc166_cx | 94aa0d5f91c48af12b0cbd20fc83af94f7d09ca7"
